<div mat-dialog-title>
  <h2>General Logic notes</h2>
</div>
<div mat-dialog-content>
  <mat-form-field class="general-progNotes__field" appearance="outline">
    <textarea matInput [(ngModel)]="data.programmerNotes" rows="4" [required]="true" [placeholder]="'Enter your notes here'" autocomplete="off"></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button cdkFocusInitial color="primary" (click)="onSave()">Save</button>
</div>
